import { MockDomainError } from 'src/api/_mock/util';

// Shared across the comms domain (channels/feedback/banners). REQ-8/10/23/22.
export type ChannelId = 'email' | 'sms' | 'letter' | 'suomifi';

export class CommsError extends MockDomainError {}
